import { render } from "./TuUpload.vue?vue&type=template&id=205ff7af"
import script from "./TuUpload.vue?vue&type=script&lang=js"
export * from "./TuUpload.vue?vue&type=script&lang=js"

import "./TuUpload.vue?vue&type=style&index=0&id=205ff7af&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__